import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginComponent } from './auth/login/login.component';
import { HttpClientModule } from '@angular/common/http';
// import { HttpModule, Http, RequestOptions } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './core/services/header.interceptor';
//import { AuthInterceptor } from './core/services/auth.interceptor';
import { environment } from '../environments/environment';
import { VTService } from './core/services/vt.service';
import { UserAuthService } from './core/services/user.auth.service';
import { UserSession } from './core/services/user.session';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { UserSessionObject } from './common/entities/user-session-object';
import { DataService } from './core/services/dataservice';
import { SuppliesElementComponent } from './supplies-element/supplies-element.component';
import { HomeLayoutComponent } from './common/layout/home-layout.component';
import { VitalSuppliesBaseModule } from './base/base.module';
import { LoginLayoutComponent } from './common/layout/login-layout.component';
// import '../CustomElement/vi';
@NgModule({
  declarations: [
    AppComponent,
    // LoginComponent,
    // SuppliesElementComponent,
    HomeLayoutComponent,
    LoginLayoutComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  exports: [FormsModule, ReactiveFormsModule, BrowserModule],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [VTService, DataService, UserAuthService, UserSession, UserSessionObject], 
  bootstrap: [AppComponent]
})
export class AppModule { }
